module.exports = __webpack_public_path__ + "static/img/logo.89746e59.svg";